var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", staticStyle: { "margin-top": "10px" } },
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.cbUseParent,
                            callback: function($$v) {
                              _vm.cbUseParent = $$v
                            },
                            expression: "cbUseParent"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": "70px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ControlMode2"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.rbgMode,
                            callback: function($$v) {
                              _vm.rbgMode = $$v
                            },
                            expression: "rbgMode"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ReminderMode"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LockMode")))
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "15px" },
                          attrs: { size: "medium", type: "success" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.rbgMode === 2
                                  ? this.$t("CargoMsg.Cargo_CreditOnlyReminder")
                                  : this.$t(
                                      "CargoMsg.Cargo_CreditLimitExceededApproval"
                                    )
                              ) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SystemMaintenance.DesignatedCargoControlRange"
                        ),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.ncCustomerId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ncCustomerId", $$v)
                            },
                            expression: "form.ncCustomerId"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_AuthorizedClient"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.ncDesignationAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "ncDesignationAgent", $$v)
                            },
                            expression: "form.ncDesignationAgent"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_NominatedAgent"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.ncReceivableChargeAccountId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "ncReceivableChargeAccountId",
                                $$v
                              )
                            },
                            expression: "form.ncReceivableChargeAccountId"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.AccountsReceivableSettlementUnits"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "SystemMaintenance.RangeOfSelfPickupControl"
                        ),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.scCustomerId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "scCustomerId", $$v)
                            },
                            expression: "form.scCustomerId"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_AuthorizedClient"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.scDesignationAgent,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "scDesignationAgent", $$v)
                            },
                            expression: "form.scDesignationAgent"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_NominatedAgent"))
                          )
                        ]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.form.scReceivableChargeAccountId,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "scReceivableChargeAccountId",
                                $$v
                              )
                            },
                            expression: "form.scReceivableChargeAccountId"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SystemMaintenance.AccountsReceivableSettlementUnits"
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-bottom": "5px" } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.WarningConfiguration"),
                        "label-width": "120px"
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Limit")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "50px", "margin-left": "2px" },
                        attrs: {
                          min: 0,
                          max: 99,
                          precision: 0,
                          controls: false
                        },
                        model: {
                          value: _vm.form.creditLimitAlarmRatio,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "creditLimitAlarmRatio", $$v)
                          },
                          expression: "form.creditLimitAlarmRatio"
                        }
                      }),
                      _c(
                        "span",
                        [
                          _vm._v(" % "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                placement: "bottom",
                                content: _vm.$t(
                                  "SystemMaintenance.UsersAlertNotifyAfterUsingXX"
                                )
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  "font-size": "16px",
                                  "vertical-align": "text-bottom"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c("span", { staticStyle: { "margin-left": "15px" } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AccountPeriod")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "50px", "margin-left": "2px" },
                        attrs: { min: 0, precision: 0, controls: false },
                        model: {
                          value: _vm.form.warnDateLimit,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "warnDateLimit", $$v)
                          },
                          expression: "form.warnDateLimit"
                        }
                      }),
                      _c(
                        "span",
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Days")) + " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                placement: "bottom",
                                content: _vm.$t(
                                  "SystemMaintenance.UsersAlertNotifyBeforeExpireDate"
                                )
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question",
                                staticStyle: {
                                  "font-size": "16px",
                                  "vertical-align": "text-bottom"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.cbUseParent
        ? _c("div", {
            staticStyle: {
              position: "absolute",
              top: "40px",
              left: "0",
              right: "0",
              bottom: "0",
              "background-color": "rgba(0,0,0,.2)",
              cursor: "not-allowed",
              "z-index": "10"
            }
          })
        : _vm._e(),
      _c("div", { staticStyle: { display: "flex", flex: "1" } }, [
        _c(
          "div",
          { staticStyle: { flex: "1" } },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Notification")))
            ]),
            _c("cargo-ag-grid", {
              staticStyle: { height: "calc(100% - 30px)" },
              attrs: {
                "show-side-bar": false,
                "grid-options": _vm.adAlert.gridOptions,
                "column-defs": _vm.adAlertColumnDefs,
                "row-data": _vm.adAlert.rowData
              }
            })
          ],
          1
        ),
        _c("div", { staticStyle: { flex: "1", "margin-left": "5px" } }, [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LockingControl")))
          ]),
          _c(
            "div",
            {
              staticClass: "tabs-container",
              staticStyle: { height: "calc(100% - 30px)" }
            },
            [
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock1,
                      expression: "tnLock1"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameSE,
                    callback: function($$v) {
                      _vm.activeTabNameSE = $$v
                    },
                    expression: "activeTabNameSE"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 1,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingSE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingSE.gridOptions,
                          "column-defs": _vm.dgOrderTakingSEColumnDefs,
                          "row-data": _vm.dgOrderTakingSE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 2,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Print"),
                        name: "dgPrint"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgPrint.gridOptions,
                          "column-defs": _vm.dgPrintColumnDefs,
                          "row-data": _vm.dgPrint.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { key: 3, attrs: { label: "EDI", name: "dgEDI" } },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgEDI.gridOptions,
                          "column-defs": _vm.dgEDIColumnDefs,
                          "row-data": _vm.dgEDI.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 4,
                      staticClass: "section",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BLRelease"),
                        name: "dgCargoDocSE"
                      }
                    },
                    [
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "section ",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.dgCargoDocSE.tableData,
                              border: "",
                              stripe: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeName",
                                label: _vm.$t("CargoMsg.Cargo_Type"),
                                width: "300px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "date",
                                label: _vm.$t("CargoMsg.Cargo_Operation"),
                                width: "300px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "260px" },
                                          attrs: { clearable: "" },
                                          model: {
                                            value: scope.row.type,
                                            callback: function($$v) {
                                              _vm.$set(scope.row, "type", $$v)
                                            },
                                            expression: "scope.row.type"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_NoLock"
                                              ),
                                              value: "0"
                                            }
                                          }),
                                          scope.row.typeName === "只有HBL"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "只有HBL扣HBL",
                                                  value: "1"
                                                }
                                              })
                                            : _vm._e(),
                                          scope.row.typeName === "只有MBL"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "只有MBL扣MBL",
                                                  value: "1"
                                                }
                                              })
                                            : _vm._e(),
                                          scope.row.typeName ===
                                          "HBL & MBL同时有"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "HBL、MBL同时扣",
                                                  value: "1"
                                                }
                                              })
                                            : _vm._e(),
                                          scope.row.typeName ===
                                          "HBL & MBL同时有"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "只扣HBL不扣MBL",
                                                  value: "2"
                                                }
                                              })
                                            : _vm._e(),
                                          scope.row.typeName ===
                                          "HBL & MBL同时有"
                                            ? _c("el-option", {
                                                attrs: {
                                                  label: "不扣HBL只扣MBL",
                                                  value: "3"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock2,
                      expression: "tnLock2"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameAE,
                    callback: function($$v) {
                      _vm.activeTabNameAE = $$v
                    },
                    expression: "activeTabNameAE"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 11,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingAE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingAE.gridOptions,
                          "column-defs": _vm.dgOrderTakingAEColumnDefs,
                          "row-data": _vm.dgOrderTakingAE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 22,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Print"),
                        name: "dgPrintAE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgPrintAE.gridOptions,
                          "column-defs": _vm.dgPrintAEColumnDefs,
                          "row-data": _vm.dgPrintAE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 33,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_DocumentCirculation"),
                        name: "dgFile"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgFile.gridOptions,
                          "column-defs": _vm.dgFileColumnDefs,
                          "row-data": _vm.dgFile.rowData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock3,
                      expression: "tnLock3"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameSI,
                    callback: function($$v) {
                      _vm.activeTabNameSI = $$v
                    },
                    expression: "activeTabNameSI"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 111,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingSI"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingSI.gridOptions,
                          "column-defs": _vm.dgOrderTakingSIColumnDefs,
                          "row-data": _vm.dgOrderTakingSI.rowData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock4,
                      expression: "tnLock4"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameAI,
                    callback: function($$v) {
                      _vm.activeTabNameAI = $$v
                    },
                    expression: "activeTabNameAI"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 1,
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingAI"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingAI.gridOptions,
                          "column-defs": _vm.dgOrderTakingAIColumnDefs,
                          "row-data": _vm.dgOrderTakingAI.rowData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock5,
                      expression: "tnLock5"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameRE,
                    callback: function($$v) {
                      _vm.activeTabNameRE = $$v
                    },
                    expression: "activeTabNameRE"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingRE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingRE.gridOptions,
                          "column-defs": _vm.dgOrderTakingREColumnDefs,
                          "row-data": _vm.dgOrderTakingRE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Print"),
                        name: "dgPrintRE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgPrintRE.gridOptions,
                          "column-defs": _vm.dgPrintREColumnDefs,
                          "row-data": _vm.dgPrintRE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "EDI", name: "dgEDIRE" } },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgEDIRE.gridOptions,
                          "column-defs": _vm.dgEDIRE.columnDefs,
                          "row-data": _vm.dgEDIRE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticClass: "section",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BLRelease"),
                        name: "dgCargoDocRE"
                      }
                    },
                    [
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "section ",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.dgCargoDocRE.tableData,
                              border: "",
                              stripe: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeName",
                                label: _vm.$t("CargoMsg.Cargo_Type"),
                                width: "300px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "date",
                                label: _vm.$t("CargoMsg.Cargo_Operation"),
                                width: "300px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-select", {
                                        staticStyle: { width: "260px" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: scope.row.type,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "type", $$v)
                                          },
                                          expression: "scope.row.type"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock6,
                      expression: "tnLock6"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameRI,
                    callback: function($$v) {
                      _vm.activeTabNameRI = $$v
                    },
                    expression: "activeTabNameRI"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingRI"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingRI.gridOptions,
                          "column-defs": _vm.dgOrderTakingRIColumnDefs,
                          "row-data": _vm.dgOrderTakingRI.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Print"),
                        name: "dgPrintRI"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgPrintRI.gridOptions,
                          "column-defs": _vm.dgPrintRIColumnDefs,
                          "row-data": _vm.dgPrintRI.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "EDI", name: "dgEDIRI" } },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgEDIRI.gridOptions,
                          "column-defs": _vm.dgEDIRI.columnDefs,
                          "row-data": _vm.dgEDIRI.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      staticClass: "section",
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BLRelease"),
                        name: "dgCargoDocRI"
                      }
                    },
                    [
                      [
                        _c(
                          "el-table",
                          {
                            staticClass: "section ",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.dgCargoDocRI.tableData,
                              border: "",
                              stripe: ""
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeName",
                                label: _vm.$t("CargoMsg.Cargo_Type"),
                                width: "300px"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "date",
                                label: _vm.$t("CargoMsg.Cargo_Operation"),
                                width: "300px"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-select", {
                                        staticStyle: { width: "260px" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: scope.row.type,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "type", $$v)
                                          },
                                          expression: "scope.row.type"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ]
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tnLock7,
                      expression: "tnLock7"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeTabNameIE,
                    callback: function($$v) {
                      _vm.activeTabNameIE = $$v
                    },
                    expression: "activeTabNameIE"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OrderReceiving"),
                        name: "dgOrderTakingIE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgOrderTakingIE.gridOptions,
                          "column-defs": _vm.dgOrderTakingIEColumnDefs,
                          "row-data": _vm.dgOrderTakingIE.rowData
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Print"),
                        name: "dgPrintIE"
                      }
                    },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          "show-side-bar": false,
                          "grid-options": _vm.dgPrintIE.gridOptions,
                          "column-defs": _vm.dgPrintIEColumnDefs,
                          "row-data": _vm.dgPrintIE.rowData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }